
import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/List.vue';
import DoctorsModule from '@/store/doctors';

@Component({
    components: {
        Layout,
        ListBlock,
    },
})
export default class DoctorsPage extends Vue {
    repository = DoctorsModule;

    get filterSettings() {
        return DoctorsModule.filter.filterSettings;
    }

    toAdd() {
        this.$router.push({ name: 'doctors_create' });
    }

    async updateList() {
        await this.repository.filter.updateFilter();
        await this.repository.updatePage('1');
    }

    async resetFilters() {
        await this.repository.clearSort();
        await this.repository.filter.resetFilter();
        await this.repository.updatePage('1');
    }
}
